import { render, staticRenderFns } from "./ElderlyOrderMonthOut.vue?vue&type=template&id=25909ca3&scoped=true&"
import script from "./ElderlyOrderMonthOut.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrderMonthOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25909ca3",
  null
  
)

export default component.exports